import React from 'react';
import { Navigate } from 'react-router-dom';

export default function SignOut() {
    localStorage.clear();
    return <Navigate to="/signin" replace />

}
